import { Box } from "@chakra-ui/layout";
import * as React from "react";
import { useAddressGeopoint } from "./AddressStateProvider";
import { useHistory } from "react-router";
import { PlacesAutocomplete } from "./PlacesAutocomplete";
import { geocodeByPlaceId } from "../utils";
import { okhiTracker } from "../OkHiTracker";

function getGeoLocation(): Promise<{
  location: { lat: number; lng: number };
  accuracy: number;
}> {
  return window
    .fetch(
      `https://www.googleapis.com/geolocation/v1/geolocate?key=${process.env.REACT_APP_GMAP_API_KEY}`,
      {
        method: "POST",
      }
    )
    .then(async (response) => {
      const data = await response.json();
      if (response.ok) {
        return data;
      }
      return Promise.reject(data);
    });
}

const DEFAULT_GEOLOC_RADIUS = 60000;

export function PlaceInputScreen() {
  const { setAddressGeoPoint } = useAddressGeopoint();
  const history = useHistory();
  const [value, setValue] = React.useState<{
    label: string;
    value: google.maps.places.AutocompletePrediction;
  } | null>(null);
  const [geoPoint, setGeoPoint] =
    React.useState<google.maps.LatLngLiteral | null>(null);
  //const placeInputRef = React.useRef<HTMLInputElement>(null);
  const handlePlacesValueChange = async (
    value: {
      label: string;
      value: google.maps.places.AutocompletePrediction;
    } | null
  ) => {
    setValue(value);
    if (value != null) {
      const geocodes = await geocodeByPlaceId(value.value.place_id);
      const latLng = {
        lat: geocodes[0].geometry.location.lat(),
        lng: geocodes[0].geometry.location.lng(),
      };
      setAddressGeoPoint(latLng);
      history.push("/map");
      okhiTracker.track("Place Found", {
        eventGeoPoint: `${latLng.lat}, ${latLng.lng}`,
        onObject: "googlePlacesApi",
        action: "tapclick",
      });
    }
  };
  const handleOnFindOnMap = () => {
    if (geoPoint) {
      setAddressGeoPoint(geoPoint);
      history.push("/map");
      okhiTracker.track("Button Tapped", {
        label: "Find on map",
        onObject: "button",
        action: "tapclick",
      });
    }
  };
  React.useEffect(() => {
    okhiTracker.page();
    getGeoLocation()
      .then((geoLoc) => {
        setGeoPoint({ ...geoLoc.location });
      })
      .catch((error) => {
        console.error("Failed to geolocate");
        console.error(error);
      });
  }, []);
  return (
    <Box>
      {/* {okhiMessage?.type === "failedToAcquireGeoloc" && (
        <Alert colorScheme="purple">
          <AlertDescription>
            Sorry, we couldn't get an accurate location
          </AlertDescription>
        </Alert>
      )} */}
      <Box p={6}>
        <PlacesAutocomplete
          value={value}
          location={geoPoint ?? undefined}
          radius={DEFAULT_GEOLOC_RADIUS}
          onChange={handlePlacesValueChange}
          onFindOnMap={geoPoint ? handleOnFindOnMap : undefined}
        />
      </Box>
    </Box>
  );
}
